<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section v-menu-permission="'list'" class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter ref="emListFilter" :entity="modelName"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesQualityToolManageTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table ref="emTable" :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'"
                                      enable-over-check
                                      importEnabled withCustomRowActions with-custom-row-actions-first-column
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <b-button-group>
                                            <em-button
                                                    type="edit" custom-icon="fa fa-fw fa-lg fa-link"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    custom-label="epc code管理"
                                                    @success="refresh"
                                                    @click="operateEpcCode(row)">
                                            </em-button>
                                        </b-button-group>
                                    </div>
                                </template>
                                <template #left-header>
                                    <stock-task-print
                                            :selected-items="selectedRows"
                                            :tag-business-code="5"
                                            :tag-material-code="1"
                                            :print-label-text=printLabelText
                                            :request-param="dynamicRequestParam"
                                            @refresh="handleSuccessEmit"
                                            @taskCreatedSuccess = "handleGoto"
                                    />
                                    <em-button v-menu-permission="'edit'"
                                               custom-icon="fa fa-file-upload fa-lg fa-arrow-down"
                                               custom-label="上传检定报告"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="uploadFileDialog()"
                                    ></em-button>
                                    <em-button v-menu-permission="'edit'"
                                               :disabled="$store.state[modelName].checkedItems.length !== 1"
                                               custom-icon="fa fa-hand-lizard-o"
                                               custom-label="借出"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="checkBorrowStatus"
                                    ></em-button>
                                    <em-button v-menu-permission="'edit'"
                                               :disabled="$store.state[modelName].checkedItems.length < 1"
                                               custom-icon="fa fa-check-square"
                                               custom-label="批量送检"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="batchCheck"
                                    ></em-button>
                                    <em-button v-menu-permission="'edit'"
                                               :disabled="$store.state[modelName].checkedItems.length < 1"
                                               custom-icon="fa fa-arrow-circle-left"
                                               custom-label="批量到库"
                                               type="edit"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="batchReceive"
                                    ></em-button>
                                    <b-button :disabled="$store.state[modelName].checkedItems.length < 1"
                                              size="sm"
                                              variant="outline-primary"
                                              @click="validUntilDialogVisible=true"
                                    >设置有效期
                                    </b-button>
                                </template>
                                <template slot="customRowActions" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button v-menu-permission="'edit'"
                                                   :disabled="customRowScope.row.status === '报废'"
                                                   custom-icon="fa fa-trash"
                                                   custom-label="报废"
                                                   type="edit"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="openScrap(customRowScope.row)"
                                        ></em-button>
                                        <em-button v-menu-permission="'edit'"
                                                   :disabled="customRowScope.row.status !== '借出'"
                                                   custom-icon="fa fa-hand-lizard-o"
                                                   custom-label="借出记录"
                                                   type="edit"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="linkBorrowRecord(customRowScope.row)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog
            append-to-body
            :center="true"
            :visible.sync="uploadDialogVisible"
            title="上传文件"
            width="30%">
            <el-form label-width="80px" size="small">

                <!--   上传文件   -->
                <el-form-item label="上传">
                    <el-upload
                        ref="upload"
                        :action="entityBaseUrl+'uploadCheckResults'"
                        :auto-upload="false"
                        :headers="headers"
                        :limit="100"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        accept=".pdf"
                        multiple
                        style="width: 80%;"
                    >
                        <div slot="trigger" class="sith-upload"><i class="el-icon-upload"/> 添加检定文件(PDF)</div>
                        <div slot="tip" class="el-upload__tip">可上传文件不超过500M</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadFile">确 定</el-button>
      </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogScrapVisible" title="报废原因" append-to-body>
            <el-form :model="form">
                <el-form-item label="报废类型">
                    <el-select v-model="scrapType" placeholder="请选择">
                        <el-option
                            v-for="item in scrapTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="原因描述">
                    <el-input v-model="reasonDescription" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogScrapVisible = false">取 消</el-button>
                <el-button type="primary" @click="scrap">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogBorrowVisible" title="借出量具" append-to-body>
            <el-form :model="form">
                <el-form-item label="借用人姓名">
                    <el-input v-model="name" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="借用人主管">
                    <el-input v-model="manager" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="借用人部门">
                    <el-input v-model="department" autocomplete="off" type="textarea"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogBorrowVisible = false">取 消</el-button>
                <el-button type="primary" @click="borrow">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="validUntilDialogVisible" title="设置有效期" append-to-body>
            <el-form :inline="true">
                <el-form-item label="有效期">
                    <el-date-picker
                        v-model="validUntil"
                        placeholder="选择日期"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="validUntilDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateValidUntil">确 定</el-button>
            </div>
        </el-dialog>
        <epc-bind-dialog
                :visible.sync="showEpcDialog"
                :bind-id="currentBindId"
                @success="refresh"
                :tag-business-code=5
        />
    </div>
</template>
<script>
// Author Shi Wenlong
// Date 2021-06-07 14:32:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import moment from "moment";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import StockTaskPrint from "@/components/em/EmEpc/StocktakeTaskAndPrint.vue";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import EpcBindDialog from "@/components/em/EmEpc/EmBindEpcComponent.vue";
import {trim} from "lodash";

export default {
    name: "sithMesQualityToolManageListView",
    components: {EpcBindDialog, StockTaskPrint},
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, emTableCheckedMixin,emCustomVuexMixin],
    data() {
        return {
            showEpcDialog: false,
            currentBindId: 0,
            uploadDialogVisible: false,
            dialogScrapVisible: false,
            validUntilDialogVisible: false,
            reasonDescription: '',
            scrapType: '',
            dialogBorrowVisible: false,
            name: '',
            form: {},
            manager: '',
            department: '',
            validUntil: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            scrapTypes: [
                {
                    value: '校验常规报废',
                    label: '校验常规报废'
                },
                {
                    value: '自然损耗报废',
                    label: '自然损耗报废'
                },
                {
                    value: '丢失报废',
                    label: '丢失报废'
                },
                {
                    value: '异常损坏报废',
                    label: '异常损坏报废'
                },
                {
                    value: '其他',
                    label: '其他'
                }
            ],
            scrapForm: {
                serialNumberNew: '',
                scrapType: '',
                reasonDescription: ''
            },
            needScrapRow: null
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi('sithMesQualityToolCheckResult')}/`
        },
        selectedRows() {
            return this.selectedItems;
        },
        dynamicRequestParam() {
            let requestParam = [];
            for (let i = 0; i < this.selectedItems.length; i++) {
                requestParam.push({
                    "arcTypeLevelOne": trim(this.selectedItems[i].type),
                    "arcName": trim(this.selectedItems[i].name),
                    "arcCode": functionGetCode(this.selectedItems[i].serialNumberNew,this.selectedItems[i].serialNumberOld),
                    "arcSize": trim(this.selectedItems[i].specification),
                    "expectedBin": trim(this.selectedItems[i].storageLoc),
                    "expectedQuantity": '1',
                    "epcCode": trim(this.selectedItems[i].epcCode)
                })
            }
            return requestParam;

            function functionGetCode(newCode, oldCode) {
                if (newCode) {
                    return `${newCode}(${oldCode || ''})`;
                } else {
                    return oldCode || '';
                }
            }
        }


    },
    methods: {
        printLabelText(row) {
            if (row.serialNumberNew && row.serialNumberOld) {
                return `${row.serialNumberNew}(${row.serialNumberOld})`;
            } else if(row.serialNumberNew){
                return row.serialNumberNew
            } else {
                return row.serialNumberOld
            }
        },
        handleChange(file) {
            if (file.size > 500 * 1024 * 1024) {
                this.$message.warning({
                    duration: 10000,
                    message: "文件超过500M，请压缩后再上传"
                });
            }
        },
        handleGoto(response) {
            this.$_emGotoMixin_gotoHolderList("emStocktakingTask"
                    , {taskCodeFilter: response}
                    , {taskCode: response}
                    , false, {'taskBusinessType':5})
        },
        operateEpcCode(row) {
            this.currentBindId = row.id;
            this.showEpcDialog = true;
        },
        refresh() {
            this.$refs.emListFilter.doQuery();
        },
        handleSuccess() {
            this.$refs.upload.clearFiles();
            this.$router.push({name: 'sithMesQualityToolCheckResultList'});
        },
        handleSuccessEmit() {
            this.$refs.emListFilter.doQuery();
        },
        uploadFileDialog() {
            this.uploadDialogVisible = true;
        },
        uploadFile() {
            this.$refs.upload.submit();
            this.uploadDialogVisible = false;
        },
        openScrap(row) {
            this.scrapForm.serialNumberNew = row.serialNumberNew;
            this.scrapForm.scrapType = row.scrapType;
            this.scrapForm.reasonDescription = row.reasonDescription;
            this.needScrapRow = row;
            this.dialogScrapVisible = true;
        },
        scrap() {
            let row = this.needScrapRow;
            let param = {'entity': 'sithMesQualityToolScrap'};
            row.toolId = row.serialNumberNew;
            row.scrapReason = this.reasonDescription;
            row.scrapType = this.scrapType;
            param.entityAux = row;
            this.$store.dispatch('emBase/emBaseCustomSave', param);
        },
        borrow() {
            this.dialogBorrowVisible = false;
            let row = this.$store.state[this.modelName].entity;
            let param = {'entity': 'sithMesQualityToolBorrowRecord'};
            row.toolCode = row.serialNumberNew;
            row.toolName = row.name;
            row.borrowPersonName = this.name;
            row.borrowerManager = this.manager;
            row.borrowerDepartment = this.department;
            param.entityAux = row;
            this.$store.dispatch('emBase/emBaseCustomSave', param);
        },
        linkBorrowRecord(row) {
            row.toolCode = row.serialNumberNew;
            this.$router.push({name: 'sithMesQualityToolBorrowRecordList', params: row});
        },
        checkBorrowStatus() {
            let row = this.$store.state[this.modelName].entity;
            this.dialogBorrowVisible = row.status === '在库';
            if (!this.dialogBorrowVisible) {
                this.$store.dispatch("base/showDanger", {
                    userAlertDangerStr: "只有在库的量具才可以借出",
                    userAlertDangerVisible: true,
                }, {root: true});
            }
        },
        batchCheck() {
            let entityModel = this.$store.state[this.modelName];
            const items = entityModel.rows.filter(row => entityModel.checkedItems.indexOf(row.id) !== -1);
            if (items.some((item) => item.status !== '在库')) {
                this.$store.dispatch("base/showDanger", {
                    userAlertDangerStr: "只有在库的量具才可以检定",
                    userAlertDangerVisible: true,
                }, {root: true});
                return;
            }
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesQualityToolManage/updateAllToCheck";
            this.$_emApiMixin_post(url, items).then(response => {
                this.$refs['emListFilter'].doQuery();
            });
        },
        batchReceive() {
            let entityModel = this.$store.state[this.modelName];
            const items = entityModel.rows.filter(row => entityModel.checkedItems.indexOf(row.id) !== -1);
            if (items.some((item) => item.status !== '送检')) {
                this.$store.dispatch("base/showDanger", {
                    userAlertDangerStr: "只有送检的量具才可以到库",
                    userAlertDangerVisible: true,
                }, {root: true});
                return;
            }
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesQualityToolManage/updateAllToReceive";
            this.$_emApiMixin_post(url, items).then(response => {
                this.$refs['emListFilter'].doQuery();
            });
        },
        updateValidUntil() {
            this.validUntilDialogVisible = false;
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesQualityToolManage/updateValidUntil";
            this.$_emApiMixin_post(url, {'ids': ids, 'target': this.validUntil}).then(() => {
                commonViewsUtil.showSuccess(this, "修改完成！");
                this.$refs['emListFilter'].doQuery();
            });
        }
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
